import React from 'react';

interface Props {
  fillColor?: string;
}
function FilterIcon({ fillColor = 'white' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none">
      <g clipPath="url(#clip0_166_2033)">
        <path
          d="M18.5173 2.5H1.85059L8.51725 10.3833V15.8333L11.8506 17.5V10.3833L18.5173 2.5Z"
          stroke={fillColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_166_2033">
          <rect
            width="20"
            height="20"
            fill={fillColor}
            transform="translate(0.183594)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default FilterIcon;
